import React from 'react'
import { Link } from 'react-router-dom'
export default function Privacypolicy() {
    const sattaName = "https://a-71ajsatta.com"
    const sattaWebsite = "https://a-71ajsatta.com"
    return (
        <div>
            <section className="textcenter">
                        <div className="text-center">
                            <h1 className='text-white'>
                                <Link to="#" className="blink text-white" >
                                <a href={sattaWebsite}>{sattaWebsite}</a>                                    <b></b>
                                </Link>
                            </h1>
                        </div>
               
            </section>
            <div className="satta-container">
                <div className="satta-inner">
                    <marquee className="satta-marquee">
                        A-71 SATTA| Satta Game | Satta Result | Satta Record Chart | Gali Desawar Gaziabad Gazipur |
                         Satta Number | Today Satta Result | Fix Leak Satta Company Number | Superfast Satta Result | Live Satta Result | 
                         Satta Lucky Number | Satta Bazaar | Kalyan Milan Main Mumbai | Matka Reults | Satta Matka Results |

                        {/* Add the rest of the marquee content as it is */}
                    </marquee>
                </div>
            </div>
            <div className="privacy-policy">
            <h1 className="main-heading">Privacy Policy for {sattaName}</h1>

            <p className="content">
                At {sattaName}, accessible from <a href={sattaWebsite}>{sattaWebsite}</a>, one of our main priorities is the privacy of our visitors. 
                This Privacy Policy document contains types of information that is collected and recorded by {sattaName} and how we use it.
            </p>

            <p className="content">
                If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
            </p>

            <h2 className="sub-heading">Log Files</h2>

            <p className="content">
                {sattaName} follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting 
                companies do this as part of hosting services' analytics. The information collected by log files includes internet protocol (IP) 
                addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks.
                 These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends
                 , administering the site, tracking users' movement on the website, and gathering demographic information.
            </p>

            <h2 className="sub-heading">Privacy Policies</h2>

            <p className="content">
                You may consult this list to find the Privacy Policy for each of the advertising partners of {sattaName}
            </p>

            <p className="content">
                Third-party ad servers or ad networks use technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on {sattaName}, which are sent directly to users' browsers. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
            </p>

            <p className="content">
                Note that {sattaName} has no access to or control over these cookies that are used by third-party advertisers.
            </p>

            <h2 className="sub-heading">Third Party Privacy Policies</h2>

            <p className="content">
                {sattaName} Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
            </p>

            <p className="content">
                You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites. What Are Cookies?
            </p>

            <h2 className="sub-heading">Children's Information</h2>

            <p className="content">
                Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
            </p>

            <p className="content">
                {sattaName} does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
            </p>

            <h2 className="sub-heading">Online Privacy Policy Only</h2>

            <p className="content">
                This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collected on {sattaName}. This policy is not applicable to any information collected offline or via channels other than this website.
            </p>

            <h2 className="sub-heading">Consent</h2>

            <p className="content">
                By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.
            </p>
        </div>
        </div>
    )
}


